import { colorPalette} from "./var/baseStyle";
const block = {}
try {
  const elObj = require.context('../../../../../src/theme', true, /\.theme.js$/)
  if(elObj){
    elObj.keys().forEach(key => {
        console.log(key,'ewrwerwer')
      let name = (key.split('.js')[0]).split('/')[1]
      const el = elObj(key).default
      if(!el) return
      let newEl = {...colorPalette,...el}
      block[name] = newEl
      block['default'] = {...colorPalette}
    })
  }
} catch (error) {
    block['default'] = {...colorPalette}
}
export default block
